// Typed client for the admin article-comment moderation surface
// (PROP-80). Mirrors property-reviews-api.ts (PROP-77).

import { api } from "./api";

export type ModerationFilter = "reported" | "hidden" | "all";

export interface CommentReportEntry {
  reporter_user_id: string;
  reporter_name: string;
  reason: string;
  note?: string;
  created_at: string;
}

export interface ModerationComment {
  id: string;
  article_id: string;
  author_user_id: string;
  author_name: string;
  body: string;
  status: "visible" | "hidden" | "deleted";
  report_count: number;
  created_at: string;
  updated_at: string;
  reports: CommentReportEntry[];
}

export interface ModerationListResponse {
  comments: ModerationComment[] | null;
  filter: ModerationFilter;
  next_cursor?: string;
}

export interface ModerationActionResponse {
  comment: ModerationComment;
  audit_logged: boolean;
}

export async function listModerationComments(opts: {
  filter?: ModerationFilter;
  limit?: number;
  cursor?: string;
} = {}): Promise<ModerationListResponse> {
  const params: string[] = [];
  if (opts.filter) params.push(`filter=${encodeURIComponent(opts.filter)}`);
  if (opts.limit) params.push(`limit=${opts.limit}`);
  if (opts.cursor) params.push(`cursor=${encodeURIComponent(opts.cursor)}`);
  const q = params.length ? `?${params.join("&")}` : "";
  const resp = await api.get<ModerationListResponse>(`/admin/article-comments${q}`);
  return { ...resp, comments: resp.comments ?? [] };
}

function action(id: string, verb: "hide" | "restore" | "delete", reason: string): Promise<ModerationActionResponse> {
  return api.post<ModerationActionResponse>(
    `/admin/article-comments/${encodeURIComponent(id)}/${verb}`,
    { reason },
  );
}

export const hideComment = (id: string, reason: string) => action(id, "hide", reason);
export const restoreComment = (id: string, reason: string) => action(id, "restore", reason);
export const deleteCommentAsAdmin = (id: string, reason: string) => action(id, "delete", reason);
